// remove nulls for cleanliness since feedback-bff will fill in any missing
// attributes that are required when creating a feedback request
export const cleanFeedbackRequests = (feedbackRequestData) =>
	Object.keys(feedbackRequestData)
		.filter((key) => feedbackRequestData[key] !== null)
		.reduce((a, key) => ({ ...a, [key]: feedbackRequestData[key] }), {});
